import { Base } from '@studiometa/js-toolkit';
import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText';

/**
 * Homepage class.
 */
export default class Sidebar extends Base {
  /**
   * Class config
   * @type {Object}
   */
  static config = {
    name: 'Sidebar',
    refs: ['burger', 'nav', 'link[]', 'menu', 'infos', 'bg', 'breadcrumb'],
  };

  /**
   * Mount component
   * @returns {void}
   */
  mounted() {
    gsap.registerPlugin(SplitText);
    this.body = document.querySelector('body');
    this.createTimeline();
    this.current = this.$refs.breadcrumb.textContent;
  }

  /**
   * Change letter on breadcrumb
   * @param  {Object} e
   * @returns {void}
   */
  onLinkClick(e) {
    const { letter } = e.currentTarget.dataset;
    if (this.current === letter) {
      this.closeMenu();
      return;
    }
    this.current = letter;
    this.$refs.breadcrumb.textContent = letter;
  }

  /**
   * Create timeline to open menu animation
   * @returns {void}
   */
  createTimeline() {
    const mySplitText = new SplitText(this.$refs.link, {
      type: 'chars',
      charsClass: 'sidebar__menu-link-chars',
    });
    this.chars = mySplitText.chars;

    this.tl = gsap.timeline();
    this.tl.pause();
    this.tl.fromTo(
      this.$refs.menu,
      { scaleX: 0 },
      { scaleX: 1, duration: 0.5, ease: 'power3.out' }
    );
    this.tl.fromTo(
      this.chars,
      { x: '-105%' },
      {
        duration: 1,
        x: '0',
        stagger: {
          each: 0.01,
        },
        ease: 'power3.out',
        delay: 0.4,
      },
      '-=0.6'
    );
    this.tl.to(this.$refs.infos, { opacity: 1 }, '-=0.75');
  }

  /**
   * Click on burger menu
   * @returns {void}
   */
  onBurgerClick() {
    if (!this.open) {
      this.openMenu();
    } else {
      this.closeMenu();
    }
  }

  /**
   * Open Menu
   * @returns {void}
   */
  openMenu() {
    this.tl.play();
    this.body.classList.add('menu-open');
    this.open = true;
  }

  /**
   * Close menu
   * @returns {void}
   */
  closeMenu() {
    this.tl.reverse();
    this.body.classList.remove('menu-open');
    this.open = false;
  }

  /**
   * ESC Click !
   * @param  {Object} e
   * @returns {void}
   */
  keyed(e) {
    if (e.ESC) {
      this.closeMenu();
    }
  }
}
